<template>
  <div class="container-fluid">
    <Breadcrumbs title="Perfil De Usuario" main="Mi Perfil" />
    <div class="row">
      <div class="col-12">
        <!-- Banner del usuario -->
        <div class="card border-0 shadow-sm overflow-hidden perfil-banner">
          <div class="perfil-banner-gradient"></div>
          <div class="card-body text-center position-relative pt-5 pb-4">
            <div class="perfil-avatar-wrapper mx-auto mb-3">
              <div class="perfil-avatar rounded-circle d-flex align-items-center justify-content-center">
                <span class="fw-bold">{{ initials }}</span>
              </div>
              <div class="perfil-avatar-edit">
                <vue-feather type="edit-3" size="14" />
              </div>
            </div>
            <h4 class="fw-bold mb-1">{{ nombreCompleto || 'Usuario' }}</h4>
            <p class="text-muted small mb-2">{{ nombreRol }}</p>
            <div class="d-flex justify-content-center gap-4 flex-wrap">
              <span class="d-flex align-items-center gap-2 text-muted small">
                <vue-feather type="mail" size="16" />
                {{ userEmail || '—' }}
              </span>
              <!-- <span class="d-flex align-items-center gap-2 text-muted small">
                <vue-feather type="map-pin" size="16" />
                {{ sucursal }}
              </span> -->
            </div>
          </div>
        </div>

        <!-- Información de la cuenta -->
        <div class="card border-0 shadow-sm mt-4">
          <div class="card-body p-4">
            <h5 class="card-title text-muted small text-uppercase mb-4">Información de la Cuenta</h5>
            <div class="perfil-info-list">
              <div class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="user" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Nombre completo</div>
                  <div>{{ nombreCompleto || '—' }}</div>
                </div>
              </div>
              <div class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="mail" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Correo electrónico</div>
                  <div>{{ userEmail || '—' }}</div>
                </div>
              </div>
              <div class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="briefcase" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Rol</div>
                  <div>{{ nombreRol }}</div>
                </div>
              </div>
              <!-- <div class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="map-pin" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Sucursal por Defecto</div>
                  <div>{{ sucursal }}</div>
                </div>
              </div> -->
              <div class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="shield" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Estado</div>
                  <span class="badge bg-success">{{ estadoLabel }}</span>
                </div>
              </div>
              <div v-if="fechaCreacion" class="perfil-info-item d-flex align-items-start gap-3 py-3 border-bottom">
                <vue-feather type="calendar" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Fecha de Creación</div>
                  <div>{{ fechaCreacion }}</div>
                </div>
              </div>
              <div v-if="fechaActualizacion" class="perfil-info-item d-flex align-items-start gap-3 py-3">
                <vue-feather type="refresh-cw" size="20" class="text-muted flex-shrink-0 mt-1" />
                <div>
                  <div class="small text-muted fw-semibold">Última Actualización</div>
                  <div>{{ fechaActualizacion }}</div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <router-link to="/dashboard/cambiar-contraseña"
                class="btn btn-primary d-inline-flex align-items-center gap-2">
                <vue-feather type="settings" size="18" />
                Cambiar Contraseña
              </router-link>
            </div>
          </div>
        </div>

        <!-- Seguridad -->
        <div class="card border-0 shadow-sm mt-4">
          <div class="card-body p-4">
            <h5 class="card-title text-muted small text-uppercase mb-3">Seguridad</h5>
            <router-link to="/dashboard/mi-perfil/dispositivos"
              class="perfil-opcion d-flex align-items-center gap-3 py-2">
              <vue-feather type="smartphone" size="20" class="text-muted flex-shrink-0" />
              <div class="flex-grow-1">
                <div class="fw-semibold">Administra tus dispositivos</div>
                <div class="small text-muted">Consulta en qué dispositivos iniciaste sesión y cierra las sesiones que no reconozcas.</div>
              </div>
              <vue-feather type="chevron-right" size="20" class="text-muted flex-shrink-0" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

function formatearFecha(fechaStr) {
  if (!fechaStr) return "";
  try {
    const d = new Date(fechaStr);
    return new Intl.DateTimeFormat("es-ES", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
  } catch {
    return fechaStr;
  }
}

export default {
  name: "PerfilUsuario",
  computed: {
    ...mapState("autenticacion", ["usuarioActual", "roles"]),
    userEmail() {
      return this.usuarioActual?.email || "";
    },
    nombreCompleto() {
      return this.usuarioActual?.name || "";
    },
    initials() {
      const name = this.nombreCompleto;
      const email = this.userEmail;
      if (name) {
        const parts = name.trim().split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
          return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
      }
      if (email) {
        const part = email.split("@")[0] || "";
        return part.slice(0, 2).toUpperCase();
      }
      return "US";
    },
    nombreRol() {
      const rolId = this.usuarioActual?.rol;
      if (!rolId) return "—";
      const rol = (this.roles || []).find((r) => String(r.id) === String(rolId));
      return rol?.name || "—";
    },
    sucursal() {
      return this.usuarioActual?.sucursal || "Todas las sucursales";
    },
    estadoLabel() {
      const s = this.usuarioActual?.status;
      if (s === "active") return "activo";
      if (s === "inactive") return "inactivo";
      return s || "activo";
    },
    fechaCreacion() {
      return formatearFecha(this.usuarioActual?.created_at);
    },
    fechaActualizacion() {
      return formatearFecha(this.usuarioActual?.updated_at);
    },
  },
};
</script>

<style scoped>
.perfil-banner {
  position: relative;
}

.perfil-banner-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: linear-gradient(135deg, #6f42c1 0%, #fd7e14 100%);
}

.perfil-avatar-wrapper {
  position: relative;
  width: fit-content;
}

.perfil-avatar {
  width: 90px;
  height: 90px;
  background: #f8d7e8;
  color: #333;
  font-size: 1.75rem;
}

.perfil-avatar-edit {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 28px;
  height: 28px;
  background: #0d6efd;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.perfil-info-item:last-child {
  border-bottom: none !important;
}

.perfil-opcion {
  color: inherit;
  text-decoration: none;
  border-radius: 8px;
}

.perfil-opcion:hover {
  color: #5c61f2;
}
</style>
